import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, CancelUpcomingTransactionDialogueHandler } from '../types';
import CancelUpcomingTransactionDialogueContext from './CancelTransactionContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type CancelUpcomingTransactionDialogueProps = {
  handleDialogue: DialogueHandler<CancelUpcomingTransactionDialogueHandler>;
};

type FC = FunctionComponent<CancelUpcomingTransactionDialogueProps>;

const CancelUpcomingTransactionDialogue: FC = ({ handleDialogue }: CancelUpcomingTransactionDialogueProps) => {
  const { showCancelUpcomingTransactionErrorAlert, sendCancelUpcomingTransactionError } = useContext(
    CancelUpcomingTransactionDialogueContext,
  );

  const { t } = useTranslation('translations', { keyPrefix: 'ScheduledTransactions.Details.History.Dialogues' });

  return useMemo(
    () => (
      <div>
        {/* Upcoming Transaction Cancel Error */}
        <ConfirmationDialogue
          isVisible={showCancelUpcomingTransactionErrorAlert}
          title={t('UpcomingTransactionCancelError.title')}
          status="error"
          subTitle={`${sendCancelUpcomingTransactionError}`}
          confirm={{
            label: t('UpcomingTransactionCancelError.backButton'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showCancelUpcomingTransactionErrorAlert, sendCancelUpcomingTransactionError],
  );
};

export default CancelUpcomingTransactionDialogue;
